"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInspectionPreviewAttendeeDto = instanceOfInspectionPreviewAttendeeDto;
exports.InspectionPreviewAttendeeDtoFromJSON = InspectionPreviewAttendeeDtoFromJSON;
exports.InspectionPreviewAttendeeDtoFromJSONTyped = InspectionPreviewAttendeeDtoFromJSONTyped;
exports.InspectionPreviewAttendeeDtoToJSON = InspectionPreviewAttendeeDtoToJSON;
exports.InspectionPreviewAttendeeDtoToJSONTyped = InspectionPreviewAttendeeDtoToJSONTyped;
/**
 * Check if a given object implements the InspectionPreviewAttendeeDto interface.
 */
function instanceOfInspectionPreviewAttendeeDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function InspectionPreviewAttendeeDtoFromJSON(json) {
    return InspectionPreviewAttendeeDtoFromJSONTyped(json, false);
}
function InspectionPreviewAttendeeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function InspectionPreviewAttendeeDtoToJSON(json) {
    return InspectionPreviewAttendeeDtoToJSONTyped(json, false);
}
function InspectionPreviewAttendeeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}
